function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length >= 2) return parts.pop().split(';').shift();
}

function submitEvent(hostname, type, contentId) {
  var clickId = getCookie('rtkclickid-store');
  if (!clickId || clickId === 'undefined') {
    clickId = sessionStorage.getItem('rtkclickid');
  }
  if (!clickId || clickId === 'undefined') {
    setTimeout(function () {
      submitEvent(hostname, type, contentId);
    }, 1000);
    return;
  }
  console.log(type);
  console.log(
    '[RT] Submitting event:',
    type,
    '| contentid:',
    contentId || 'none'
  );
  var xhr = new XMLHttpRequest();
  var postbackUrl = `${hostname}/postback?clickid=${clickId}&type=${type}&eventid=${clickId}`;
  if (contentId) {
    postbackUrl += `&contentid=${contentId}`;
  }
  xhr.open('GET', postbackUrl);
  xhr.send();
  if (type === 'viewcontent' || type === 'addtocart') {
    var xhr2 = new XMLHttpRequest();
    xhr2.open('POST', '/cart/update.js');
    xhr2.setRequestHeader('Content-Type', 'application/json');
    xhr2.send(
      JSON.stringify({
        attributes: {
          __clickid: clickId
        }
      })
    );
  }
}

function detectProductByMeta() {
  try {
    return meta && meta.product;
  } catch (e) {
    return false;
  }
}

function detectProductByCartForm() {
  return document.querySelector("form[action='/cart/add']");
}

function getProductIdFromMeta() {
  try {
    return meta && meta.product && meta.product.id ? meta.product.id : null;
  } catch (e) {
    return null;
  }
}

var rtPathArray = 'https://track.shoppingeventvip.net/eventsv2.js'.split('/');
var rtProtocol = rtPathArray[0];
var rtHost = rtPathArray[2];
var rtHostname = rtProtocol + '//' + rtHost;
var rtCartFormDetected = false;
var rtIsProduct = false;
document.addEventListener('DOMContentLoaded', function () {
  if (detectProductByMeta() || detectProductByCartForm()) {
    rtIsProduct = true;
  } else {
    // CASE 1: viewcontent — handle fallback (not a detected product page, but URL resolves to a product)
    var path = window.location.pathname;
    var potentialHandle = path.substring(path.lastIndexOf('/') + 1);
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.status == 200) {
        var fallbackProductId = null;
        try {
          var productData = JSON.parse(xhr.responseText);
          if (productData && productData.product && productData.product.id) {
            fallbackProductId = productData.product.id;
          }
        } catch (e) {}
        console.log(
          '[RT] viewcontent (handle fallback) | product_id:',
          fallbackProductId || 'not found'
        );
        submitEvent(rtHostname, 'viewcontent', fallbackProductId);
      }
    };
    xhr.open('GET', `/products/${potentialHandle}.json`);
    xhr.send();
  }
  if (rtIsProduct) {
    // CASE 2: viewcontent — product page detected via meta.product or cart form
    var rtProductId = getProductIdFromMeta();
    console.log(
      '[RT] viewcontent (product page) | product_id:',
      rtProductId || 'not found'
    );
    submitEvent(rtHostname, 'viewcontent', rtProductId);

    document.body.addEventListener('click', function (event) {
      if (
        event.target.className &&
        event.target.className
          .toString()
          .indexOf('shopify-payment-button__button') !== -1
      ) {
        submitEvent(rtHostname, 'buynow');
      }
    });
  }
});

(function () {
  var open = window.XMLHttpRequest.prototype.open;

  function openReplacement() {
    this.addEventListener('load', function () {
      if (
        this._url &&
        this._url.indexOf('/products/') !== -1 &&
        this._url.indexOf('view=ajax') !== -1
      ) {
        // CASE 3: viewcontent — AJAX product load (quick-view / collection page)
        // Extract handle from the AJAX URL and fetch product JSON to get the ID
        var ajaxProductId = null;
        try {
          var ajaxUrl = this._url.split('?')[0]; // e.g. /products/some-handle
          var ajaxHandle = ajaxUrl.substring(ajaxUrl.lastIndexOf('/') + 1);
          var productXhr = new XMLHttpRequest();
          productXhr.onreadystatechange = function () {
            if (productXhr.readyState === 4 && productXhr.status === 200) {
              try {
                var pData = JSON.parse(productXhr.responseText);
                if (pData && pData.product && pData.product.id) {
                  ajaxProductId = pData.product.id;
                }
              } catch (e) {}
              console.log(
                '[RT] viewcontent (ajax product load) | product_id:',
                ajaxProductId || 'not found'
              );
              submitEvent(rtHostname, 'viewcontent', ajaxProductId);
            }
          };
          productXhr.open('GET', `/products/${ajaxHandle}.json`);
          productXhr.send();
        } catch (e) {
          console.log(
            '[RT] viewcontent (ajax product load) | product_id: error extracting'
          );
          submitEvent(rtHostname, 'viewcontent');
        }

        setTimeout(function () {
          var cartForms = document.querySelectorAll("form[action='/cart/add']");
          if (cartForms) {
            cartForms.forEach(function (cartForm) {
              cartForm.addEventListener('submit', function (e) {
                console.log(e);
                // CASE 4: addtocart — form submit after AJAX product load
                // Try form inputs, then data attributes, then meta fallback
                var formProductId = null;
                try {
                  var productIdInput = cartForm.querySelector(
                    'input[name="product-id"], input[data-productid]'
                  );
                  if (productIdInput) {
                    formProductId = productIdInput.value;
                  }
                  if (!formProductId) {
                    formProductId = getProductIdFromMeta();
                  }
                } catch (ex) {}
                console.log(
                  '[RT] addtocart (form submit) | product_id:',
                  formProductId || 'not found'
                );
                submitEvent(rtHostname, 'addtocart', formProductId);
                rtCartFormDetected = true;
              });
            });
          }
        }, 2000);
      }
      var url = this._url ? this._url.split('?')[0] : this._url;
      url = url ? url.split('&')[0] : url;
      url = url
        ? url.substr(url.indexOf('/cart/') !== -1 ? url.indexOf('/cart/') : 0)
        : url;
      if (
        [
          `/cart/add`,
          `/cart/add.js`
          //`/cart/update.js`,
          //`/cart/change.js`,
          //`/cart/clear.js`,
        ].includes(url)
      ) {
        if (!rtCartFormDetected) {
          // CASE 5: addtocart — XHR intercept for /cart/add or /cart/add.js
          // Shopify's response JSON contains product_id
          var xhrAddProductId = null;
          try {
            var responseData = JSON.parse(this.responseText);
            if (responseData && responseData.product_id) {
              xhrAddProductId = responseData.product_id;
            }
          } catch (e) {}
          console.log(
            '[RT] addtocart (xhr intercept) | product_id:',
            xhrAddProductId || 'not found'
          );
          submitEvent(rtHostname, 'addtocart', xhrAddProductId);
        }
      }
    });
    return open.apply(this, arguments);
  }

  window.XMLHttpRequest.prototype.open = openReplacement;
})();

(function (ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function () {
    var response = fetch.apply(this, arguments);

    response.then(res => {
      var url = res.url ? res.url.split('?')[0] : res.url;
      url = url ? url.split('&')[0] : url;
      url = url
        ? url.substr(url.indexOf('/cart/') !== -1 ? url.indexOf('/cart/') : 0)
        : url;
      if (
        [
          `/cart/add`,
          `/cart/add.js`
          //`/cart/update.js`,
          //`/cart/change.js`,
          //`/cart/clear.js`,
        ].includes(url)
      ) {
        res
          .clone()
          .json()
          .then(data => {
            if (!rtCartFormDetected) {
              // CASE 6: addtocart — fetch intercept for /cart/add or /cart/add.js
              // Shopify's response JSON contains product_id
              var fetchProductId =
                data && data.product_id ? data.product_id : null;
              console.log(
                '[RT] addtocart (fetch intercept) | product_id:',
                fetchProductId || 'not found'
              );
              submitEvent(rtHostname, 'addtocart', fetchProductId);
            }
          });
      }
    });

    return response;
  };
})(window, window.fetch);
